var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#0B93E3",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 35.9998V31.9998C28.5 31.3198 28.556 30.6498 28.666 29.9998M52.5 35.9998V31.9998C52.5002 29.5623 51.758 27.1825 50.3723 25.1772C48.9866 23.1718 47.0231 21.636 44.743 20.7742C42.4629 19.9123 39.9745 19.7652 37.6087 20.3525C35.243 20.9398 33.1123 22.2336 31.5 24.0618M38.5 59.9998H32.5C26.844 59.9998 24.014 59.9998 22.258 58.2418C20.5 56.4858 20.5 53.6558 20.5 47.9998C20.5 42.3438 20.5 39.5138 22.258 37.7578C24.014 35.9998 26.844 35.9998 32.5 35.9998H48.5C54.156 35.9998 56.986 35.9998 58.742 37.7578C60.5 39.5138 60.5 42.3438 60.5 47.9998C60.5 53.6558 60.5 56.4858 58.742 58.2418C56.986 59.9998 54.156 59.9998 48.5 59.9998H46.5",
    stroke: "#0B93E3",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/no-access.6ed3addd97d9e61b53370d4a19a88028.svg";
export { ForwardRef as ReactComponent };